import { createContext, useContext, useState } from 'react';

const ClientSettingsContext = createContext();
const ClientSettingsDispatch = createContext();

const ClientSettingsProvider = ({ children }) => {
	const [settings, setSettings] = useState({});
	return (
		<ClientSettingsContext.Provider value={settings}>
			<ClientSettingsDispatch.Provider value={setSettings}>{children}</ClientSettingsDispatch.Provider>
		</ClientSettingsContext.Provider>
	);
};

const useClientSettingsState = () => {
	const context = useContext(ClientSettingsContext);
	if (context === undefined) {
		throw new Error('useClientSettingsState must be used within a ClientSettingsProvider');
	}
	return context;
};

const useClientSettingsDispatch = () => {
	const context = useContext(ClientSettingsDispatch);
	if (context === undefined) {
		throw new Error('useClientSettingsDispatch must be used within a ClientSettingsProvider');
	}
	return context;
};

export { ClientSettingsProvider, useClientSettingsState, useClientSettingsDispatch };
